import { Component } from '@angular/core';

@Component({
    selector: 'app-rvhost-loader',
    templateUrl: './rvhost-loader.component.html',
    styleUrls: ['./rvhost-loader.component.scss']
})
export class RvhostLoaderComponent {

}
